<template>
  <div class="containerFull" >
    <div class="row justify-content-center" style="margin-top:10px">
      <div class="col-sm-12 col-md-4 col-lg-3" v-for="(item, index) in  items" :key="index">
       <text-card :item="item" @goToNote="goToNote" @goToNotes="goToNotes"></text-card>
      </div>
    </div>

    
    <div class="button-circle-more secondary" v-if="LastEvaluatedKey">
      <button class="button circle-more tooltip tooltip-left" data-tooltip="cargar más" @click="loadMore">
        <svg viewBox="0 0 18 18">
          <g id="Grupo_29" data-name="Grupo 29" transform="translate(-171 -753)">
            <rect
              id="Rectángulo_redondeado_903"
              data-name="Rectángulo redondeado 903"
              width="2"
              height="18"
              rx="1"
              transform="translate(179 753)"
              fill="#fff"
            />
            <rect
              id="Rectángulo_redondeado_903_copia"
              data-name="Rectángulo redondeado 903 copia"
              width="18"
              height="2"
              rx="1"
              transform="translate(171 761)"
              fill="#fff"
            />
          </g>
        </svg>
      </button>
    </div>
    <!-- END BUTTON CIRCLE -->
  </div>
  <!--- end container -->
</template>


<script>
import textCard from "@/components/textCard";


//import keywordsNotes from "@/components/keywordsNotes";
//import fiNotes from "@/components/fiNotes";


export default {
  name: "panelText",
  components: { textCard },
  props: ["items","LastEvaluatedKey"],
  data() {
    return {
      url: this.$store.getters.getMainUrl
    };
  },

  mounted(){
   
  },
  methods: {
    goToNote(params) {
      this.$emit("goToNote", params);
    },
    goToNotes(params) {
      this.$emit("goToNotes", params);
    },
    loadMore() {
      this.$emit("loadMore");
    }
  }
};
</script>
<style>
.top-actions button {
  margin: 0px 5px !important;
  font-size: 14px !important;
  padding: 10px 15px !important;
}
</style>